module.exports = __webpack_public_path__ + "img/nt1-08-75-1_1.prt.5c38e8db.jpg";